







import Vue from 'vue';
import Component from 'vue-class-component';
import { PageTitle } from '@questelservices/common-vue';
import InvoiceLookupGrid from '@/components/invoice-lookup/invoice-lookup-grid.vue';

@Component({
  components: {
    InvoiceLookupGrid,
    PageTitle
  }
})
export default class InvoiceLookup extends Vue {}
